export default "__VITE_ASSET__DYixbz1y__"